<div class="container-fluid">
  <div class="row flex-nowrap">
    <div class="col-auto col-xl-2 px-sm-2 px-0 bg-light scrollable-div">
      <div
        class="d-flex flex-column align-items-center align-items-sm-start px-3 pt-2 min-vh-100"
      >
        <span class="fs-5 d-none d-sm-inline">
          APIs
          <a
            href="javascript:void(0)"
            (click)="getUsecase(0)"
            class="btn btn-outline-primary btn-sm"
            ><i class="fa fa-plus"></i>Add</a
          ></span
        >
        <input
          [(ngModel)]="searchUsecaseItem"
          type="text"
          class="form-control form-control-sm mr-2"
          id="searchUsecase"
          name="searchUsecase"
          placeholder="Search usecase"
        />
        <ul
          class="nav nav-pills flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start"
          id="menu"
        >
          <!-- *ngFor="let e of this.userstoryList; let i = index"  -->
          <li
            class="nav-item"
            *ngFor="let e of filterUsecases(); let i = index"
          >
            <a href="javascript:void(0)" (click)="getUsecase(e['id'])">
              <i class="fa fa-plus"></i
              ><span class="ms-1 d-none d-sm-inline">{{ e["name"] }}</span>
            </a>
            |
            <a href="../udata/{{ e['code'] }}" target="_blank"
              ><i class="fa fa-save"></i
            ></a>
            |
            <!-- <a  [routerLink]="../usecasedata/{{e['id']}}">  <i class="fa fa-database"></i></a> | -->
            <a [routerLink]="'/usecasedata/' + e.id">
              <i class="fa fa-database"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-md-3 py-2">
      <p>
        <form-error [form]="form"></form-error>
      </p>
      <form class="border border-primary rounded px-3 py-3 mb-2">
        <H2>{{ form.data["name"] }} </H2>
        <div class="mb-2">
          <label for="name" class="form-label">Name</label>
          <div class="input-group mb-2">
            <input
              required="true"
              [(ngModel)]="form.data['name']"
              type="text"
              class="form-control form-control-sm"
              id="name"
              name="name"
              placeholder="Eneter name"
            />
          </div>
        </div>
        <div class="mb-2">
          <label for="code" class="form-label">Code</label>
          <div class="input-group mb-2">
            <input
              [disabled]="true"
              [(ngModel)]="form.data['code']"
              type="text"
              class="form-control form-control-sm"
              id="code"
              name="code"
              placeholder="code"
            />
          </div>
        </div>
        <div class="mb-2">
          <label for="description" class="form-label">Description</label>
          <textarea
            rows="5"
            [(ngModel)]="form.data['description']"
            class="form-control form-control-sm"
            id="description"
            name="description"
            placeholder="Enter description"
          ></textarea>
        </div>
        <button type="submit" (click)="save()" class="btn btn-success btn-sm">
          <i class="fa fa-save"></i> Save
        </button>
      </form>
    </div>
    <div class="col py-3 col-md-2">
      <H2>Enable</H2>
      <div>
        <div class="form-check form-switch mb-1">
          <input
            [(ngModel)]="form.data['commentEnabled']"
            class="form-check-input"
            type="checkbox"
            role="switch"
            id="comment"
            name="comment"
            (change)="
              this.toggleVal(
                form.data['commentEnabled'],
                form.data,
                'commentEnabled'
              )
            "
          />
          <label class="form-check-label" for="comment">Page comment</label>
          <p class="text-danger" for="comment"></p>
        </div>
        <div class="form-check form-switch mb-1">
          <input
            [(ngModel)]="form.data['emailEnabled']"
            class="form-check-input"
            type="checkbox"
            role="switch"
            id="email"
            name="email"
            (change)="
              this.toggleVal(
                form.data['emailEnabled'],
                form.data,
                'emailEnabled'
              )
            "
          />
          <label class="form-check-label" for="email">Page email</label>
        </div>
        <div class="form-check form-switch mb-1">
          <input
            [(ngModel)]="form.data['attachmentEnabled']"
            class="form-check-input"
            type="checkbox"
            role="switch"
            id="attachment"
            name="attachment"
            (change)="
              this.toggleVal(
                form.data['attachmentEnabled'],
                form.data,
                'attachmentEnabled'
              )
            "
          />
          <label class="form-check-label" for="export">Page Attachment</label>
        </div>
        <div class="form-check form-switch mb-1">
          <input
            [(ngModel)]="form.data['groupFilter']"
            class="form-check-input"
            type="checkbox"
            role="switch"
            id="groupFilter"
            name="groupFilter"
            (change)="
              this.toggleVal(form.data['groupFilter'], form.data, 'groupFilter')
            "
          />
          <label class="form-check-label" for="export">Group Filter</label>
        </div>
        <hr />
        <div class="form-check form-switch mb-1">
          <input
            [(ngModel)]="form.data['versionHistory']"
            class="form-check-input"
            type="checkbox"
            role="switch"
            id="version"
            name="version"
            (change)="
              this.toggleVal(
                form.data['versionHistory'],
                form.data,
                'versionHistory'
              )
            "
          />
          <label class="form-check-label" for="version">Data versioning</label>
        </div>
        <div class="form-check form-switch mb-1">
          <input
            [(ngModel)]="form.data['archiveEnabled']"
            class="form-check-input"
            type="checkbox"
            role="switch"
            id="archived"
            name="archived"
            (change)="
              this.toggleVal(
                form.data['archiveEnabled'],
                form.data,
                'archiveEnabled'
              )
            "
          />
          <label class="form-check-label" for="archived">Data archive</label>
        </div>
        <div class="form-check form-switch mb-1">
          <input
            [(ngModel)]="form.data['changeLog']"
            class="form-check-input"
            type="checkbox"
            role="switch"
            id="changeLog"
            name="changeLog"
            (change)="
              this.toggleVal(form.data['changeLog'], form.data, 'changeLog')
            "
          />
          <label class="form-check-label" for="changeLog"
            >Data change log</label
          >
        </div>
        <hr />
        <div class="form-check form-switch mb-1">
          <input
            [(ngModel)]="form.data['exportEnabled']"
            class="form-check-input"
            type="checkbox"
            role="switch"
            id="export"
            name="export"
            (change)="
              this.toggleVal(
                form.data['exportEnabled'],
                form.data,
                'exportEnabled'
              )
            "
          />
          <label class="form-check-label" for="export">Excel export</label>
        </div>
      </div>
    </div>
    <div class="col-md-3 py-3 col-md-2">
      <form class="border border-primary rounded px-3 py-3">
        <H2>Relation</H2>
        <div class="mb-2">
          <div class="input-group mb-2">
            <button for="dropdown" class="btn btn-outline-primary btn-sm">
              List Label
            </button>
            <select
              class="form-select form-select-sm"
              id="dropdown"
              name="dropdown"
              #dropdown
            >
              <option val="">--Select--</option>
              <option
                *ngFor="let e of filterAttributes()"
                value="{{ e['code'] }}"
              >
                {{ e["label"] }}
              </option>
            </select>
            <button
              (click)="updateList('dropdown', dropdown.value, false)"
              class="btn btn-outline-primary btn-sm"
            >
              <i class="fa fa-plus"></i>Add
            </button>
          </div>
          <div class="mb-2">
            <button
              *ngFor="let e of form.data['dropdown']"
              (click)="updateList('dropdown', e, true)"
              type="button"
              class="btn btn-outline-secondary btn-sm"
            >
              {{ e }} <i class="fa fa-remove"></i>
            </button>
          </div>
        </div>
        <div class="mb-2">
          <div class="input-group mb-2">
            <button
              for="excelAttributes"
              class="btn btn-outline-primary btn-sm"
            >
              Export Colms
            </button>
            <select
              class="form-select form-select-sm"
              id="excelAttributes"
              name="excelAttributes"
              #excelAttributes
            >
              <option value="">--Select--</option>
              <option
                *ngFor="let e of filterAttributes()"
                value="{{ e['code'] }}"
              >
                {{ e["label"] }}
              </option>
            </select>
            <button
              (click)="
                updateList('excelAttributes', excelAttributes.value, false)
              "
              class="btn btn-outline-primary btn-sm"
            >
              <i class="fa fa-plus"></i>Add
            </button>
          </div>
          <div class="mb-2">
            <button
              *ngFor="let e of form.data['excelAttributes']"
              (click)="updateList('excelAttributes', e, true)"
              type="button"
              class="btn btn-outline-secondary btn-sm"
            >
              {{ e }} <i class="fa fa-remove"></i>
            </button>
          </div>
        </div>
        <div class="mb-2">
          <div class="input-group mb-2">
            <button for="dropdownList" class="btn btn-outline-primary btn-sm">
              Ref API
            </button>
            <select
              class="form-select form-select-sm"
              id="dropdownList"
              name="dropdownList"
              #dropdownList
            >
              <option value="">--Select--</option>
              <option *ngFor="let e of form.list" value="{{ e['name'] }}">
                {{ e["name"] }}
              </option>
            </select>
            <button
              (click)="updateList('dropdownList', dropdownList.value, false)"
              class="btn btn-outline-primary btn-sm"
            >
              <i class="fa fa-plus"></i>Add
            </button>
          </div>
          <div class="mb-2">
            <button
              *ngFor="let e of form.data['dropdownList']; let i = index"
              (click)="updateList('dropdownList', e, true)"
              type="button"
              class="btn btn-outline-secondary btn-sm"
            >
              {{ e }} <i class="fa fa-remove"></i>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <h2>
    Attributes
    <button
      [disabled]="form.data['id'] == 0"
      type="button"
      (click)="getAttribute(0)"
      class="btn btn-outline-primary btn-sm"
      data-bs-toggle="modal"
      data-bs-target="#attribModel"
    >
      <i class="fa fa-plus"></i> Add
    </button>
  </h2>
  <div class="row">
    <div class="col-sm-3">
      <input
        [(ngModel)]="searchAttributeItem"
        type="text"
        class="form-control form-control-sm"
        id="searchUsecase"
        name="searchUsecase"
        placeholder="Search by label or type"
      />
    </div>
    <div class="col-sm-2">
      <button
        (click)="setAttribFilter('unique')"
        type="button"
        class="btn btn-sm"
      >
        <i class="fa fa-lightbulb-o"></i>
      </button>
      <button
        (click)="setAttribFilter('index')"
        type="button"
        class="btn btn-sm"
      >
        <i class="fa fa-info"></i>
      </button>
      <button
        (click)="setAttribFilter('required')"
        type="button"
        class="btn btn-sm"
      >
        <i class="fa fa-asterisk"></i>
      </button>
      <button
        (click)="setAttribFilter('system')"
        type="button"
        class="btn btn-sm"
      >
        <i class="fas fa-gear"></i>
      </button>
      <button
        (click)="setAttribFilter(''); searchAttributeItem = ''"
        type="button"
        class="btn btn-sm"
      >
        <i class="fa fa-eraser" aria-hidden="true"></i>
      </button>
    </div>
    <div class="col"></div>
  </div>
  <div class="row">
    <table class="table table-sm table-striped my-1">
      <thead>
        <tr>
          <th>S.No.</th>
          <th>Label</th>
          <th>Code</th>
          <th>Type</th>
          <th>Size/Min/Max</th>
          <th>description</th>
          <th>version</th>
          <th>created date</th>
          <th align="right">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let e of filterAttributesByLabelType(); let i = index">
          <td>{{ i + 1 }}</td>
          <td style="white-space: nowrap">
            <button
              (click)="getAttribute(e['id'])"
              data-bs-toggle="modal"
              data-bs-target="#attribModel"
              type="button"
              class="btn btn-outline-secondary btn-sm"
            >
              <i class="fas fa-edit"></i>
            </button>
            {{ e["label"] }}
            <button *ngIf="e['unique'] == 1" type="button" class="btn btn-sm">
              <i class="fa fa-lightbulb-o"></i>
            </button>
            <button *ngIf="e['index'] == 1" type="button" class="btn btn-sm">
              <i class="fas fa-info"></i>
            </button>
            <button *ngIf="e['required'] == 1" type="button" class="btn btn-sm">
              <i class="fas fa-asterisk"></i>
            </button>
            <button *ngIf="e['system'] == 1" type="button" class="btn btn-sm">
              <i class="fas fa-gear"></i>
            </button>
          </td>
          <td>
            {{ e["code"] }}
          </td>
          <td>
            {{ e["type"] }}
          </td>
          <td>{{ e["size"] }}/ {{ e["min"] }}/ {{ e["max"] }}</td>
          <td>
            {{ e["description"] }}
          </td>
          <td>
            {{ e["version"] }}
          </td>
          <td>
            {{ e["createdDatetime"] | date: "yyyy-MM-dd HH:mm:ss" }}
          </td>
          <td>
            <button
              (click)="this.deleteAttribute(e['id'])"
              type="button"
              class="btn btn-danger btn-sm"
            >
              <i class="fas fa-remove"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!--Add attribute Modal -->
<div
  class="modal fade"
  id="attribModel"
  tabindex="-1"
  aria-labelledby="attribModelLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="attribModelLabel">
          Attribute {{ form.data["name"] }}
        </h2>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
        <button
          *ngFor="
            let e of this.atribForm['inputerror'] | keyvalue;
            let i = index
          "
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <form class="form-horizontal" role="form" #uiForm="ngForm">
          <p *ngIf="this.atribForm['error'] == true" class="btn btn-danger">
            {{ this.atribForm["message"] }}
          </p>
          <p *ngIf="this.atribForm['error'] == false" class="btn btn-success">
            {{ this.atribForm["message"] }}
          </p>

          <li
            *ngFor="
              let e of this.atribForm['inputerror'] | keyvalue;
              let i = index
            "
            class="btn btn-warning"
          >
            {{ i + 1 }}:{{ e.value }}
          </li>
          <div class="form-row mb-2">
            <label for="label" class="col-sm-1 col-form-label col-form-label-sm"
              >Label:</label
            >
            <div class="col">
              <input
                id="label"
                [(ngModel)]="this.atribForm['data']['label']"
                name="label"
                placeholder="Enter label"
                pattern="[a-zA-Z][a-zA-Z ]+"
                required
                type="text"
                class="form-control form-control-sm"
              />
            </div>
            <p>Code:{{ atribForm["data"]["code"] }}</p>
          </div>
          <div class="form-row mb-2">
            <label for="type" class="col-sm-1 col-form-label col-form-label-sm"
              >Type:</label
            >
            <div class="col">
              <select
                [(ngModel)]="this.atribForm['data']['type']"
                id="type"
                name="type"
                required
                class="form-select form-select-sm form-select-sm"
              >
                <option select value="">--Type--</option>
                <option select value="text">text</option>
                <option select value="number">number</option>
                <option select value="long">long</option>
                <option select value="decimal">decimal</option>
                <option select value="date">date</option>
                <option select value="time">time</option>
                <option select value="email">email</option>
                <option select value="url">url</option>
                <option select value="object">object</option>
                <option select value="list">list</option>
                <option select value="map">map</option>
                <option select value="doc">doc</option>
                <option select value="file">image</option>
              </select>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col">
              <label for="description" class="form-label">Description</label>
              <textarea
                [(ngModel)]="atribForm['data']['description']"
                class="form-control form-control-sm"
                id="description"
                name="description"
                placeholder="Enter description"
              ></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <label
                for="size"
                class="col-sm-1 col-form-label col-form-label-sm"
                >Size:</label
              >
              <input
                [(ngModel)]="this.atribForm['data']['size']"
                id="size"
                name="size"
                type="number"
                value="0"
                class="form-control form-control-sm"
                placeholder="Size"
                aria-label="Size"
              />
            </div>
            <div class="col">
              <label for="min" class="col-sm-1 col-form-label col-form-label-sm"
                >Min:</label
              >
              <input
                id="min"
                [(ngModel)]="this.atribForm['data']['min']"
                name="min"
                type="number"
                value="0"
                class="form-control form-control-sm"
                placeholder="min"
                aria-label="min"
              />
            </div>
            <div class="col">
              <label for="max" class="col-sm-1 col-form-label col-form-label-sm"
                >Max:</label
              >
              <input
                [(ngModel)]="this.atribForm['data']['max']"
                id="max"
                name="max"
                type="number"
                value="0"
                class="form-control form-control-sm"
                placeholder="min"
                aria-label="max"
              />
            </div>
          </div>
          <div class="row">
            <div class="col">
              <hr />
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-check">
                <input
                  [(ngModel)]="this.atribForm['data']['required']"
                  class="form-check-input"
                  type="checkbox"
                  id="required"
                  name="required"
                  (change)="
                    this.toggleVal(
                      atribForm['data']['required'],
                      atribForm['data'],
                      'required'
                    )
                  "
                />
                <label class="form-check-label" for="required"
                  >is required?</label
                >
              </div>
            </div>
            <div class="col">
              <div class="form-check">
                <input
                  [(ngModel)]="this.atribForm['data']['index']"
                  class="form-check-input"
                  type="checkbox"
                  id="index"
                  name="index"
                  (change)="
                    this.toggleVal(
                      atribForm['data']['index'],
                      atribForm['data'],
                      'index'
                    )
                  "
                />
                <label class="form-check-label" for="index">Create index</label>
              </div>
            </div>
            <div class="col">
              <div class="form-check">
                <input
                  [(ngModel)]="atribForm['data']['unique']"
                  class="form-check-input"
                  type="checkbox"
                  id="unique"
                  name="unique"
                  (change)="
                    this.toggleVal(
                      atribForm['data']['unique'],
                      atribForm['data'],
                      'unique'
                    )
                  "
                />
                <label class="form-check-label" for="unique">unique</label>
              </div>
            </div>
            <div class="col">
              <div class="form-check">
                <input
                  [(ngModel)]="atribForm['data']['system']"
                  class="form-check-input"
                  type="checkbox"
                  id="system"
                  name="system"
                  (change)="
                    this.toggleVal(
                      atribForm['data']['system'],
                      atribForm['data'],
                      'system'
                    )
                  "
                />
                <label class="form-check-label" for="system">system</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <hr />
            </div>
          </div>
          <div class="row" *ngIf="this.atribForm['data']['type'] === 'list'">
            <div class="input-group mb-2">
              <button for="values" class="btn btn-outline-secondary btn-sm">
                Values
              </button>
              <input
                [(ngModel)]="tempAttributeValue"
                #attrValue
                id="values"
                name="values"
                type="text"
                class="form-control form-control-sm"
                placeholder="Enter a value"
              />
              <button
                (click)="addAttributeValue()"
                class="btn btn-outline-secondary btn-sm"
              >
                <i class="fa fa-plus"></i>Add
              </button>
            </div>
            <div class="mb-2">
              <button
                *ngFor="let e of this.atribForm['data']['values']"
                (click)="removeAttribueValue(e)"
                type="button"
                class="btn btn-outline-secondary btn-sm"
              >
                {{ e }} <i class="fa fa-remove"></i>
              </button>
            </div>
          </div>
          <!-- Type Map -->

          <div class="row" *ngIf="this.atribForm['data']['type'] === 'map'">
            <div class="input-group mb-2">
              <input
                [(ngModel)]="tempKey"
                id="key"
                name="key"
                type="text"
                class="form-control form-control-sm"
                placeholder="Enter a key"
              />
              <input
                [(ngModel)]="tempMapValue"
                id="tempMapValue"
                name="tempMapValue"
                type="text"
                class="form-control form-control-sm"
                placeholder="Enter a value"
              />
              <button
                (click)="addAttributeMapValue()"
                class="btn btn-outline-secondary btn-sm"
              >
                <i class="fa fa-plus"></i> Add
              </button>
            </div>
            <div class="mb-2">
              <button
                *ngFor="let item of this.atribForm['data']['values']"
                (click)="removeAttribueMapValue(item.key)"
                type="button"
                class="btn btn-outline-secondary btn-sm"
              >
                {{ item.key }}: {{ item.value }} <i class="fa fa-remove"></i>
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <hr />
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-check">
                <input
                  [(ngModel)]="atribForm['data']['refKey']"
                  class="form-check-input"
                  type="checkbox"
                  id="refKey"
                  name="refKey"
                  (change)="
                    this.toggleVal(
                      atribForm['data']['refKey'],
                      atribForm['data'],
                      'refKey'
                    )
                  "
                />
                <label class="form-check-label" for="refKey"
                  >Reference Key</label
                >
              </div>
            </div>
          </div>
          <div class="row" *ngIf="atribForm['data']['refKey'] == 1">
            <div class="col">
              <label
                for="primaryUsecase"
                class="col-sm-1 col-form-label col-form-label-sm"
                >Primary Usecase</label
              >
              <select
                [(ngModel)]="atribForm['data']['primaryUsecase']"
                class="form-select form-select-sm"
                id="primaryUsecase"
                name="primaryUsecase"
              >
                <option
                  *ngFor="let e of form.list"
                  value="{{ e['collectionName'] }}"
                >
                  {{ e["name"] }}
                </option>
              </select>
            </div>
            <div class="col">
              <label
                for="depAttribute"
                class="col-sm-1 col-form-label col-form-label-sm"
                >Dependent Attribute
              </label>
              <select
                [(ngModel)]="atribForm['data']['depAttribute']"
                class="form-select form-select-sm"
                id="depAttribute"
                name="depAttribute"
              >
                <option
                  *ngFor="let e of filterAttributes()"
                  value="{{ e['code'] }}"
                >
                  {{ e["label"] }}
                </option>
              </select>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-success btn-sm"
          (click)="saveAttribute()"
        >
          <i class="fa fa-save"></i> Save
        </button>
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          data-bs-dismiss="modal"
        >
          <i class="fa fa-window-close"></i> Close
        </button>
      </div>
    </div>
  </div>
</div>